import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { FeatureFlagService } from '../services/feature-flag/feature-flag.service';
import { AuthService } from '../services/auth/auth.service';

export const featureFlagGuard: CanActivateFn = async (route) => {
  const featureFlagService = inject(FeatureFlagService);
  const authService = inject(AuthService);

  const flag = route.data['featureFlag'] as string | undefined;
  if (!flag) return true;

  await featureFlagService.ready;

  // featureFlagFallback=false => acesso NEGADO se o PostHog não responder
  // (a flag manda de verdade; ausente/off = oculto).
  const fallback = (route.data['featureFlagFallback'] as boolean) ?? true;
  if (featureFlagService.isEnabled(flag, fallback)) {
    return true;
  }

  authService.navigateToRoleHome();
  return false;
};
